export const getEnvFromHost = (host: string) => {
  const env = host.split(".")[0];

  if (env.includes("dit") || env.includes("local") || env.includes("feature") || env.includes("dev")) return "DIT";
  if (env.includes("pre") || env.includes("preprod")) return "PRE";

  return "PROD";
};
